export const FEEDBACK_TYPES = [
  {
    label: 'Positive',
    value: 'true',
  },
  {
    label: 'Negative',
    value: 'false',
  },
];

export const SR_IMAGES_LIMIT = 10;
